import React from 'react';
import {Form, Formik} from 'formik';
import {withTranslation} from 'react-i18next';
import {Modal} from '../../../shared/modal/Modal';
import {Btn, CancelBtn} from '../../../shared/elements/btn/Btn';
import moment from 'moment';
import {Row} from '../../../shared/grid/grid-features/Row';
import {Col} from '../../../shared/grid/grid-features/Col';
import {FormDatePicker} from '../../../shared/form/form-control/FormDatePicker';
import {createExportDataSchema, downloadFileFromAxiosResponse} from './helper';
import {getAllCustomerExport} from './endpoints';

function DownloadCustomersModal({close, t}) {
    const [isExporting, setIsExporting] = React.useState(false);
    const initialValues = {
        timestampFrom: moment().add(-1, 'months').startOf('month'),
        timestampTo: moment().add(-1, 'months').endOf('month').startOf('day'),
    };

    const downloadAllCustomers = (values) => {
        setIsExporting(true);
        getAllCustomerExport(values.timestampFrom.format('YYYY-MM-DD'), values.timestampTo.format('YYYY-MM-DD'))
            .then(downloadFileFromAxiosResponse)
            .finally(() => {
                setIsExporting(false);
                close();
            });
    };
    return (
        <div>
            <Formik
                onSubmit={(values) => downloadAllCustomers(values)}
                initialValues={initialValues}
                validationSchema={createExportDataSchema(t)}
                validateOnChange
            >
                {({handleSubmit, values, setFieldValue, setFieldTouched, isValidating, isValid}) => (
                    <Form>
                        <Modal size="sm" title={t('customer.ExportAllCustomers')}>
                            <Modal.Body>
                                <Row>
                                    <Col colsize="50">
                                        <FormDatePicker
                                            portalId="datepicker-portal"
                                            label={t('warehousing.downloads.export.fromDate')}
                                            name="timestampFrom"
                                            // FormDatePicker works with Date object instead of moment
                                            selected={values.timestampFrom?.toDate()}
                                            onChange={(value) => {
                                                const date = value ? moment(value) : null;
                                                setFieldValue('timestampFrom', date);
                                            }}
                                            onBlur={() => {
                                                setFieldTouched('timestampFrom', true);
                                            }}
                                            dateFormat="dd-MM-yyyy"
                                            selectsStart
                                            startDate={values.timestampFrom?.toDate()}
                                            endDate={values.timestampTo?.toDate()}
                                        />
                                    </Col>
                                    <Col colsize="50">
                                        <FormDatePicker
                                            portalId="datepicker-portal"
                                            label={t('warehousing.downloads.export.toDate')}
                                            name="timestampTo"
                                            // FormDatePicker works with Date object instead of moment
                                            selected={values.timestampTo?.toDate()}
                                            onChange={(value) => {
                                                const date = value ? moment(value) : null;
                                                setFieldValue('timestampTo', date);
                                            }}
                                            onBlur={() => {
                                                setFieldTouched('timestampTo', true);
                                            }}
                                            dateFormat="dd-MM-yyyy"
                                            selectsEnd
                                            startDate={values.timestampFrom?.toDate()}
                                            endDate={values.timestampTo?.toDate()}
                                        />
                                    </Col>
                                </Row>
                            </Modal.Body>
                            <Modal.Footer>
                                <CancelBtn type="button" color="default" onClick={close} disabled={isExporting}>
                                    {t('general.Cancel')}
                                </CancelBtn>
                                <Btn
                                    type="submit"
                                    onClick={() => handleSubmit()}
                                    color="success"
                                    disabled={isExporting || isValidating || !isValid}
                                >
                                    {t('general.Submit')}
                                </Btn>
                            </Modal.Footer>
                        </Modal>
                    </Form>
                )}
            </Formik>
        </div>
    );
}
export default withTranslation()(DownloadCustomersModal);
